(() => {
  function matchesProductScope(body, product) {
    const productKey = product?.dataset.saPdpProduct;
    if (productKey === "letna") {
      return (
        body?.classList.contains("sa-com-handle-letna-colored") &&
        body.classList.contains("sa-com-template-letna-nenabizi-dalsi")
      );
    }
    if (productKey === "eden") {
      return (
        body?.classList.contains("sa-com-handle-eden-col") &&
        body.classList.contains("sa-com-template-eden")
      );
    }
    return false;
  }

  function initProductExperience() {
    const body = document.body;
    const product = document.querySelector(".sa-pdp-v9");
    if (!product || !matchesProductScope(body, product)) return;
    if (product.dataset.saPdpReady === "true") return;

    product.dataset.saPdpReady = "true";
    document.documentElement.classList.add("sa-pdp-v9-js");

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const revealItems = [...document.querySelectorAll("[data-sa-pdp-reveal]")];

    if (reducedMotion.matches || !("IntersectionObserver" in window)) {
      revealItems.forEach((item) => item.classList.add("is-visible"));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -8%", threshold: 0.08 }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    }

    const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (finePointer.matches && !reducedMotion.matches) {
      document
        .querySelectorAll(
          ".sa-pdp-v9 .product.grid, .sa-product-story-v9__closing"
        )
        .forEach((panel) => {
          panel.addEventListener(
            "pointermove",
            (event) => {
              const bounds = panel.getBoundingClientRect();
              const x = ((event.clientX - bounds.left) / bounds.width) * 100;
              const y = ((event.clientY - bounds.top) / bounds.height) * 100;
              panel.style.setProperty("--sa-pdp-x", `${x.toFixed(1)}%`);
              panel.style.setProperty("--sa-pdp-y", `${y.toFixed(1)}%`);
            },
            { passive: true }
          );
        });
    }

    connectQuantityBreak(product, body);
    connectMobileDock(product);
    connectChapterNavigation();
    connectWireframeParallax(reducedMotion);
    connectReviewFallback();
    connectReviewAnchor();
  }

  function connectQuantityBreak(product, body) {
    const purchasePanel = product.querySelector(".product__info-container");
    if (!purchasePanel) return;

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const language = (document.documentElement.lang || "en").toLowerCase();
    const quantityTitle = language.startsWith("cs")
      ? "Nakup další model se slevou!"
      : language.startsWith("de")
        ? "Mehr Modelle kaufen und sparen!"
        : "Buy another model and save!";

    const parseMoney = (text) => {
      const numberText = (text || "").match(/-?\d[\d\s.,]*\d|-?\d/)?.[0];
      if (!numberText) return Number.NaN;

      const compact = numberText.replace(/[\s\u00a0\u202f]/g, "");
      const commaIndex = compact.lastIndexOf(",");
      const dotIndex = compact.lastIndexOf(".");
      const decimalIndex = Math.max(commaIndex, dotIndex);
      const hasDecimals = decimalIndex >= 0 && compact.length - decimalIndex - 1 === 2;
      const normalized = hasDecimals
        ? `${compact.slice(0, decimalIndex).replace(/[.,]/g, "")}.${compact.slice(decimalIndex + 1)}`
        : compact.replace(/[.,]/g, "");

      return Number.parseFloat(normalized);
    };

    const formatMoneyLike = (value, sample) => {
      const match = (sample || "").match(/-?\d[\d\s.,]*\d|-?\d/);
      if (!match) return sample;

      const numberText = match[0];
      const compact = numberText.replace(/[\s\u00a0\u202f]/g, "");
      const commaIndex = compact.lastIndexOf(",");
      const dotIndex = compact.lastIndexOf(".");
      const decimalIndex = Math.max(commaIndex, dotIndex);
      const decimalSeparator =
        decimalIndex >= 0 && compact.length - decimalIndex - 1 === 2
          ? compact[decimalIndex]
          : "";
      const decimals = decimalSeparator ? 2 : 0;
      const integerSample = decimalSeparator ? compact.slice(0, decimalIndex) : compact;
      const groupSeparator = integerSample.includes(".")
        ? "."
        : integerSample.includes(",")
          ? ","
          : numberText.includes("\u202f")
            ? "\u202f"
            : numberText.includes("\u00a0")
              ? "\u00a0"
              : numberText.includes(" ")
                ? " "
                : "";
      const [integerPart, fractionPart] = value.toFixed(decimals).split(".");
      const groupedInteger = groupSeparator
        ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator)
        : integerPart;
      const formattedNumber = decimalSeparator
        ? `${groupedInteger}${decimalSeparator}${fractionPart}`
        : groupedInteger;

      return `${sample.slice(0, match.index)}${formattedNumber}${sample.slice(match.index + numberText.length)}`;
    };

    const syncUnitPrice = (offer) => {
      const priceBlock = product.querySelector("[data-sa-pdp-unit-price]");
      const selectedTier = offer
        .querySelector(".mpb-offer__radio-icon.checked")
        ?.closest(".mpb-offer__tier-box");
      const totalElement = selectedTier?.querySelector(".mpb-offer__price-current");
      const quantityText = selectedTier?.querySelector(".mpb-offer__tier-text-truncate")?.textContent || "";
      const quantity = Number.parseInt(quantityText.match(/\d+/)?.[0] || "1", 10);
      const total = parseMoney(totalElement?.textContent || "");
      const priceTarget = priceBlock?.querySelector(
        ".price__regular .price-item--regular, .price-item--sale"
      );
      if (!priceBlock || !priceTarget || !Number.isFinite(total) || quantity < 1) return;

      const nextPrice = formatMoneyLike(total / quantity, totalElement.textContent.trim());
      priceBlock.dataset.saPdpSelectedQuantity = String(quantity);
      if (priceTarget.textContent.trim() === nextPrice) return;

      priceTarget.textContent = nextPrice;
      if (!reducedMotion.matches && typeof priceTarget.animate === "function") {
        priceTarget.animate(
          [
            { opacity: 0.45, transform: "translateY(3px)" },
            { opacity: 1, transform: "translateY(0)" },
          ],
          { duration: 220, easing: "cubic-bezier(0.2, 0.72, 0.2, 1)" }
        );
      }
    };

    let activeOffer = null;
    let offerObserver = null;
    let readyTimer = 0;

    const setOfferInteractive = (offer, interactive) => {
      if (interactive) {
        offer.removeAttribute("inert");
        offer.removeAttribute("aria-hidden");
      } else {
        offer.setAttribute("inert", "");
        offer.setAttribute("aria-hidden", "true");
      }
    };

    const isOfferComplete = (offer) => {
      if (!offer?.isConnected) return false;

      const title = offer.querySelector(".mpb-offer__title");
      const stack = offer.querySelector(".mpb-offer__tier-stack-wrapper");
      const tiers = [...offer.querySelectorAll(".mpb-offer__tier-box")];
      const selected = offer.querySelectorAll(".mpb-offer__radio-icon.checked");

      return Boolean(
        title?.textContent.trim() &&
          stack &&
          tiers.length > 0 &&
          selected.length === 1 &&
          tiers.every((tier) => {
            const quantity = tier.querySelector(".mpb-offer__tier-text-truncate")?.textContent.trim();
            const price = tier.querySelector(".mpb-offer__price-current")?.textContent.trim();
            return quantity && price;
          })
      );
    };

    const cancelReady = () => {
      if (!readyTimer) return;
      window.clearTimeout(readyTimer);
      readyTimer = 0;
    };

    const cancelPurchaseFallback = () => {
      if (!product.saPdpPurchaseFallbackTimer) return;
      window.clearTimeout(product.saPdpPurchaseFallbackTimer);
      product.saPdpPurchaseFallbackTimer = null;
    };

    const armPurchaseFallback = () => {
      cancelPurchaseFallback();
      product.saPdpPurchaseFallbackTimer = window.setTimeout(() => {
        product.saPdpPurchaseFallbackTimer = null;
        if (product.dataset.saPdpPurchaseState !== "pending") return;
        product.dataset.saPdpPurchaseState = "fallback";
        product.dispatchEvent(new CustomEvent("sa:pdp-purchase-fallback"));
      }, 12000);
    };

    const revealOffer = (offer) => {
      if (
        product.dataset.saPdpPurchaseState !== "pending" ||
        offer !== activeOffer ||
        !isOfferComplete(offer)
      ) {
        return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (
            product.dataset.saPdpPurchaseState !== "pending" ||
            offer !== activeOffer ||
            !isOfferComplete(offer)
          ) {
            return;
          }

          cancelPurchaseFallback();
          product.dataset.saPdpPurchaseState = "ready";
          setOfferInteractive(offer, true);
          syncUnitPrice(offer);
        });
      });
    };

    const queueOfferReveal = (offer) => {
      cancelReady();
      if (product.dataset.saPdpPurchaseState !== "pending" || !isOfferComplete(offer)) return;
      readyTimer = window.setTimeout(() => {
        readyTimer = 0;
        revealOffer(offer);
      }, 300);
    };

    const syncKeychainGiftNote = (offer) => {
      if (product.dataset.saPdpProduct !== "letna") return;

      const giftText = language.startsWith("cs")
        ? "+ klíčenka zdarma"
        : language.startsWith("de")
          ? "+ gratis Schlüsselanhänger"
          : "+ free keychain";

      offer.querySelectorAll(".mpb-offer__tier-box-container").forEach((container) => {
        const tier = container.querySelector(".mpb-offer__tier-box");
        const quantity = Number.parseInt(
          tier?.querySelector(".mpb-offer__tier-text-truncate")?.textContent || "",
          10
        );
        const giftVariants = container.querySelectorAll(
          '.mpb-offer__extra-container .mpb-offer__extra-box.gift .mpb-extra-variant-selected[value-type="free_gift"]'
        );
        const hasKeychainGift = [...giftVariants].some((variant) =>
          /(?:^|\/)51911070220616$/.test(variant.value || variant.getAttribute("value") || "")
        );
        let note = tier?.querySelector("[data-sa-pdp-keychain-gift]");
        const content = tier?.querySelector(".mpb-offer__tier-content");

        if (quantity !== 3 || !hasKeychainGift || !content) {
          note?.remove();
          return;
        }

        if (!note) {
          note = document.createElement("span");
          note.className = "sa-pdp-v12__keychain-gift";
          note.setAttribute("data-sa-pdp-keychain-gift", "");
          content.appendChild(note);
        }
        if (note.textContent !== giftText) note.textContent = giftText;
      });
    };

    const syncOffer = (offer) => {
      if (!offer?.isConnected || offer !== activeOffer) return;

      let purchaseState = product.dataset.saPdpPurchaseState;
      if (purchaseState === "ready" && !isOfferComplete(offer)) {
        product.dataset.saPdpPurchaseState = "pending";
        armPurchaseFallback();
        purchaseState = "pending";
      }

      const offerIsReady = purchaseState === "ready";
      setOfferInteractive(offer, offerIsReady);
      if (purchaseState === "fallback") return;

      offer.setAttribute("data-sa-pdp-quantity-break", "");

      const title = offer.querySelector(".mpb-offer__title");
      if (title && title.textContent.trim() !== quantityTitle) title.textContent = quantityTitle;

      offer.querySelectorAll(".mpb-offer__extra-container").forEach((extra) => {
        const extraTitle = extra.querySelector(".mpb-offer__product-title")?.textContent || "";
        const copy = `${extraTitle} ${extra.textContent || ""}`;
        if (!/custom\s*text|vlastn[ií]\s*n[aá]pis|eigener\s*text/i.test(copy)) return;
        extra.remove();
      });

      syncKeychainGiftNote(offer);

      if (offer.dataset.saPdpPriceConnected !== "true") {
        offer.dataset.saPdpPriceConnected = "true";
        const queuePriceSync = (event) => {
          if (!event.target.closest(".mpb-offer__tier-box-container, .mpb-offer__tier-box")) return;
          window.requestAnimationFrame(() => {
            if (
              product.dataset.saPdpPurchaseState === "ready" &&
              offer === activeOffer
            ) {
              syncUnitPrice(offer);
            }
          });
        };
        offer.addEventListener("click", queuePriceSync);
        offer.addEventListener("change", queuePriceSync);
      }

      if (offerIsReady) syncUnitPrice(offer);
      body.classList.add("sa-pdp-v9-custom-text-removed");
      queueOfferReveal(offer);
    };

    const connectOffer = (offer) => {
      if (offer === activeOffer) return;

      const previousOffer = activeOffer;
      cancelReady();
      offerObserver?.disconnect();
      offerObserver = null;

      if (
        previousOffer &&
        product.dataset.saPdpPurchaseState !== "fallback"
      ) {
        product.dataset.saPdpPurchaseState = "pending";
        armPurchaseFallback();
      }

      activeOffer = offer;

      if (!offer || product.dataset.saPdpPurchaseState === "fallback") {
        if (offer) setOfferInteractive(offer, false);
        return;
      }

      syncOffer(offer);
      offerObserver = new MutationObserver(() => syncOffer(offer));
      offerObserver.observe(offer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    };

    const discoverOffer = () => {
      const offer = purchasePanel.querySelector(".mpb-offer--quantity_break");
      body.classList.toggle("sa-pdp-v9-has-quantity-break", Boolean(offer));
      connectOffer(offer);
    };

    product.addEventListener("sa:pdp-purchase-fallback", () => {
      cancelReady();
      cancelPurchaseFallback();
      offerObserver?.disconnect();
      offerObserver = null;
      if (activeOffer) setOfferInteractive(activeOffer, false);
    });

    discoverOffer();
    const discoveryObserver = new MutationObserver(discoverOffer);
    discoveryObserver.observe(purchasePanel, { childList: true, subtree: true });
  }

  function connectMobileDock(product) {
    const dock = document.querySelector("[data-sa-pdp-mobile-dock]");
    const dockButton = dock?.querySelector("[data-sa-pdp-mobile-trigger]");
    const dockPrice = dock?.querySelector("[data-sa-pdp-mobile-price]");
    const nativeButton = product.querySelector('button[name="add"]');
    if (!dock || !dockButton || !nativeButton) return;
    if (dock.dataset.saPdpReady === "true") return;

    if (dock.parentElement !== document.body) document.body.appendChild(dock);
    dock.dataset.saPdpReady = "true";

    const mobileViewport = window.matchMedia("(max-width: 989px)");
    let nativeButtonVisible = false;

    const isNativeButtonMeaningfullyVisible = () => {
      const bounds = nativeButton.getBoundingClientRect();
      const visibleHeight = Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0);
      return bounds.width > 0 && bounds.height > 0 && visibleHeight >= bounds.height * 0.55;
    };

    const syncVisibility = () => {
      const shouldShow = mobileViewport.matches && !nativeButtonVisible;
      dock.classList.toggle("is-visible", shouldShow);
      dock.setAttribute("aria-hidden", shouldShow ? "false" : "true");
      dockButton.tabIndex = shouldShow ? 0 : -1;
      document.body.classList.toggle("sa-pdp-v9-purchase-active", mobileViewport.matches);
    };

    const syncAvailability = () => {
      const currentButton = product.querySelector('button[name="add"]') || nativeButton;
      const unavailable = currentButton.disabled || currentButton.getAttribute("aria-disabled") === "true";
      dockButton.disabled = unavailable;
      dock.classList.toggle("is-busy", currentButton.classList.contains("loading"));
    };

    const syncDockPrice = () => {
      const priceTarget = product.querySelector(
        "[data-sa-pdp-unit-price] .price__regular .price-item--regular, [data-sa-pdp-unit-price] .price-item--sale"
      );
      const nextPrice = priceTarget?.textContent.trim();
      if (dockPrice && nextPrice && dockPrice.textContent.trim() !== nextPrice) {
        dockPrice.textContent = nextPrice;
      }
    };

    dockButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (dockButton.disabled) return;
      const currentButton = product.querySelector('button[name="add"]');
      const productForm = currentButton?.form || currentButton?.closest("form");
      if (!currentButton || !productForm) return;
      if (typeof productForm.requestSubmit === "function") productForm.requestSubmit(currentButton);
      else currentButton.click();
    });

    nativeButtonVisible = isNativeButtonMeaningfullyVisible();

    if ("IntersectionObserver" in window) {
      const buttonObserver = new IntersectionObserver(
        ([entry]) => {
          nativeButtonVisible = entry.isIntersecting && entry.intersectionRatio >= 0.55;
          syncVisibility();
        },
        { threshold: [0, 0.55, 1] }
      );
      buttonObserver.observe(nativeButton);
    }

    const buttonStateObserver = new MutationObserver(syncAvailability);
    buttonStateObserver.observe(nativeButton, {
      attributes: true,
      attributeFilter: ["disabled", "aria-disabled", "class"],
    });

    const priceBlock = product.querySelector("[data-sa-pdp-unit-price]");
    if (priceBlock) {
      const priceObserver = new MutationObserver(syncDockPrice);
      priceObserver.observe(priceBlock, { childList: true, characterData: true, subtree: true });
    }

    if (typeof mobileViewport.addEventListener === "function") {
      mobileViewport.addEventListener("change", () => {
        nativeButtonVisible = isNativeButtonMeaningfullyVisible();
        syncVisibility();
      });
    } else {
      mobileViewport.addListener(syncVisibility);
    }

    syncAvailability();
    syncDockPrice();
    syncVisibility();
  }

  function connectChapterNavigation() {
    const nav = document.querySelector("[data-sa-pdp-chapters]");
    if (!nav || nav.dataset.saPdpReady === "true") return;

    const links = [...nav.querySelectorAll("[data-sa-pdp-chapter-link]")];
    const chapters = links
      .map((link) => document.querySelector(link.getAttribute("href")))
      .filter(Boolean);
    if (!links.length || !chapters.length) return;

    nav.dataset.saPdpReady = "true";
    const track = nav.querySelector(".sa-product-story-v9__chapters-track");
    const story = nav.closest("[data-sa-pdp-story]");
    const storySection = story?.closest('[id^="shopify-section-"]');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    // Keep the chapter bar in the document flow, but let its sticky boundary span
    // the complete editorial story and the separate reviews section below it.
    if (storySection?.parentNode) storySection.parentNode.insertBefore(nav, storySection);

    const setActive = (id, center = true) => {
      const activeLink = links.find((link) => link.getAttribute("href") === `#${id}`);
      if (!activeLink) return;
      if (activeLink.classList.contains("is-active")) return;

      links.forEach((link) => {
        const active = link === activeLink;
        link.classList.toggle("is-active", active);
        if (active) link.setAttribute("aria-current", "location");
        else link.removeAttribute("aria-current");
      });

      if (center && track) {
        const left = activeLink.offsetLeft - (track.clientWidth - activeLink.offsetWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: reducedMotion.matches ? "auto" : "smooth" });
      }
    };

    const syncStickyOffset = () => {
      const header = document.querySelector(
        ".shopify-section.section-header, [id^='shopify-section-'][id$='__header']"
      );
      const bounds = header?.getBoundingClientRect();
      const visibleBottom = bounds && bounds.bottom > 0 && bounds.top < window.innerHeight
        ? Math.max(0, Math.min(bounds.bottom, bounds.height))
        : 0;
      const stickyTop = `${Math.round(visibleBottom)}px`;
      nav.style.setProperty("--sa-pdp-chapters-top", stickyTop);
      story?.style.setProperty("--sa-pdp-chapters-top", stickyTop);
      const chapterOffset = Math.round(visibleBottom + nav.offsetHeight + 16);
      chapters.forEach((chapter) => {
        chapter.style.scrollMarginTop = `${chapterOffset}px`;
      });
    };

    const syncActiveChapter = () => {
      const marker = window.scrollY + nav.offsetHeight + 42;
      let current = chapters[0];
      chapters.forEach((chapter) => {
        const chapterTop = chapter.getBoundingClientRect().top + window.scrollY;
        if (chapterTop <= marker) current = chapter;
      });
      setActive(current.id);
    };

    let offsetFrame = 0;
    const queueStickyOffset = () => {
      if (offsetFrame) return;
      offsetFrame = window.requestAnimationFrame(() => {
        offsetFrame = 0;
        syncStickyOffset();
        syncActiveChapter();
      });
    };

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        setActive(target.id);
        target.scrollIntoView({ behavior: reducedMotion.matches ? "auto" : "smooth", block: "start" });
        window.history.replaceState(null, "", `#${target.id}`);
      });
    });

    if ("IntersectionObserver" in window) {
      const chapterObserver = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top));
          if (visible[0]) setActive(visible[0].target.id);
        },
        { rootMargin: "-20% 0px -68% 0px", threshold: 0 }
      );
      chapters.forEach((chapter) => chapterObserver.observe(chapter));
    }

    window.addEventListener("scroll", queueStickyOffset, { passive: true });
    window.addEventListener("resize", queueStickyOffset, { passive: true });
    syncStickyOffset();
    syncActiveChapter();
    setActive(chapters[0].id, false);
  }

  function connectWireframeParallax(reducedMotion) {
    const stage = document.querySelector("[data-sa-pdp-wireframe]");
    const artwork = stage?.querySelector("[data-sa-pdp-wireframe-art]");
    if (!stage || !artwork || stage.dataset.saPdpReady === "true") return;

    stage.dataset.saPdpReady = "true";

    const setPosition = (progress) => {
      const travel = window.innerWidth < 750 ? 104 : 82;
      const horizontal = (0.5 - progress) * travel;
      const vertical = (0.5 - progress) * 14;
      stage.style.setProperty("--sa-wireframe-progress", progress.toFixed(4));
      stage.style.setProperty("--sa-wireframe-x", `${horizontal.toFixed(2)}px`);
      stage.style.setProperty("--sa-wireframe-y", `${vertical.toFixed(2)}px`);
    };

    if (reducedMotion.matches) {
      setPosition(0.5);
      return;
    }

    let frame = 0;
    let active = !("IntersectionObserver" in window);

    const syncPosition = () => {
      frame = 0;
      const bounds = stage.getBoundingClientRect();
      const distance = window.innerHeight + bounds.height;
      const progress = Math.min(1, Math.max(0, (window.innerHeight - bounds.top) / distance));
      setPosition(progress);
    };

    const queuePosition = () => {
      if (!active || frame) return;
      frame = window.requestAnimationFrame(syncPosition);
    };

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          active = entry.isIntersecting;
          stage.classList.toggle("is-in-view", active);
          if (active) queuePosition();
        },
        { rootMargin: "45% 0px", threshold: 0 }
      );
      observer.observe(stage);
    } else {
      stage.classList.add("is-in-view");
    }

    window.addEventListener("scroll", queuePosition, { passive: true });
    window.addEventListener("resize", queuePosition, { passive: true });
    setPosition(0);
  }

  function connectReviewAnchor() {
    const reviewLink = document.querySelector("[data-sa-pdp-review-link]");
    if (!reviewLink) return;

    const findWidget = () =>
      document.querySelector(
        ".jdgm-carousel-wrapper, .jdgm-rev-widg, .jdgm-widget[data-impressions-tracked]"
      );

    const placeMarker = (widget) => {
      let marker = document.getElementById("stadiart-reviews");
      if (!marker) {
        marker = document.createElement("span");
        marker.id = "stadiart-reviews";
        marker.className = "sa-pdp-v9__review-marker";
        marker.setAttribute("aria-hidden", "true");
        widget.before(marker);
      }
      reviewLink.hidden = false;
      return marker;
    };

    const currentWidget = findWidget();
    if (currentWidget) {
      placeMarker(currentWidget);
      return;
    }

    const observer = new MutationObserver(() => {
      const widget = findWidget();
      if (!widget) return;
      placeMarker(widget);
      observer.disconnect();
    });

    observer.observe(document.getElementById("MainContent") || document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => {
      observer.disconnect();
      if (!document.getElementById("stadiart-reviews")) reviewLink.hidden = true;
    }, 10000);
  }

  function connectReviewFallback() {
    const section = document.querySelector("[data-sa-pdp-reviews]");
    const fallback = section?.querySelector("[data-sa-reviews-fallback]");
    const carousel = section?.querySelector(".jdgm-cards-carousel");
    if (
      !section ||
      !fallback ||
      !carousel ||
      section.dataset.saPdpReviewFallbackReady === "true"
    ) {
      return;
    }

    section.dataset.saPdpReviewFallbackReady = "true";

    let observer;
    const syncFallback = () => {
      const reviewIds = new Set(
        Array.from(carousel.querySelectorAll(".jdgm-card[data-review-id]"), (card) =>
          card.getAttribute("data-review-id")
        ).filter(Boolean)
      );
      const hasLiveCards =
        !carousel.classList.contains("jdgm-hidden") &&
        carousel.querySelector(".jdgm-card") !== null;

      fallback.hidden = hasLiveCards;
      section.classList.toggle("has-live-reviews", hasLiveCards);
      section.classList.toggle(
        "has-review-navigation",
        hasLiveCards && reviewIds.size > 1
      );
      if (hasLiveCards) observer?.disconnect();
    };

    observer = new MutationObserver(syncFallback);
    observer.observe(carousel, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });
    syncFallback();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductExperience, { once: true });
  } else {
    initProductExperience();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const loadedProduct = event.target?.matches?.(".sa-pdp-v9")
      ? event.target
      : event.target?.querySelector?.(".sa-pdp-v9");
    if (loadedProduct) {
      const loadedDock = loadedProduct.querySelector("[data-sa-pdp-mobile-dock]");
      document.querySelectorAll("[data-sa-pdp-mobile-dock]").forEach((dock) => {
        if (dock !== loadedDock) dock.remove();
      });
    }

    const loadedStory = event.target?.querySelector?.("[data-sa-pdp-story]");
    if (loadedStory) {
      document.querySelectorAll("[data-sa-pdp-chapters]").forEach((nav) => {
        if (!loadedStory.contains(nav)) nav.remove();
      });
    }

    const product = loadedProduct || document.querySelector(".sa-pdp-v9");
    if (product) product.dataset.saPdpReady = "false";
    initProductExperience();
  });
})();
